import { MutationTree, ActionTree } from 'vuex'
import _get from 'lodash/get'
import instance from '../connection'
import { Moment } from 'moment'

class State {
  records = []
  total: number = 0
  pagination = {
    current: 1 as number,
    pageSize: 10 as number,
    total: 0 as number
  }
  sorter = {
    field: '' as string,
    order: '' as string
  }
  search: string = ''
  range =  {
    start: '',
    end: ''
  } as {start: string, end: string}
  organization: string| undefined = undefined
}

const getters = {
  //
}

const actions = <ActionTree<State, any>>{
  async getRecords({ state, commit }) {
    let params: any = {
      page: state.pagination.current,
      limit: state.pagination.pageSize,
      sort: state.sorter.field,
      order: state.sorter.order,
      search: state.search,
      startDate: state.range.start,
      endDate: state.range.end
    }
    if (state.organization) {
      params.org = state.organization
    }
    commit('updateRecords', await instance.get('/record', {params}))
  },
  async downloadRecords({ state}, type) {
    const params: any = {
      type,
      sort: state.sorter.field,
      order: state.sorter.order,
      search: state.search,
      startDate: state.range.start,
      endDate: state.range.end
    }
    if (state.organization) {
      params.org = state.organization
    }
    await instance.post('/record/download', params, {
      responseType: 'blob',
    })
  }
}

const mutations = <MutationTree<State>>{
  updateRecords(state, records) {
    state.records = records.data
    state.total = records.total
    state.pagination.total = records.total
  },
  updateRecordPagination(state, {current, pageSize, total}) {
    if (current) state.pagination.current = current
    if (pageSize) state.pagination.pageSize = pageSize
    if (total) state.pagination.total = total
  },
  updateRecordSorter(state, {field, order}) {
    if (field) state.sorter.field = field
    if (order) state.sorter.order = order
  },
  updateRecordSearchKey(state, search) {
    state.search = search
  },
  updateRecordRange(state, dates: Moment[]) {
    state.range.start = dates[0]? dates[0].format("YYYY-MM-DD HH:mm:ss"): ''
    state.range.end = dates[1]? dates[1].format("YYYY-MM-DD HH:mm:ss"): ''
  },
  updateCurrentRecordOrg(state, org) {
    state.organization = org
  }
}

export default {
  state: new State(),
  getters,
  actions,
  mutations
}